import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Select } from 'antd';
import { apiCreatePermission, apiUpdatePermission } from '@services/ManageRoles/RoleServices';
import { showSuccess, showError } from '@components/notification';

const { Option } = Select;

const PermissionFormModal = ({ open, onClose, editingPermission, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      if (editingPermission) {
        form.setFieldsValue({
          name: editingPermission.name,
          description: editingPermission.description
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, editingPermission, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      if (editingPermission) {
        await apiUpdatePermission(values, editingPermission.id);
        showSuccess({ message: 'Cập nhật quyền hạn thành công!' });
      } else {
        await apiCreatePermission(values);
        showSuccess({ message: 'Tạo quyền hạn thành công!' });
      }

      form.resetFields();
      onClose();
      onSuccess();
    } catch (error) {
      showError(error?.message || 'Không thể lưu quyền hạn');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={editingPermission ? 'Chỉnh sửa quyền hạn' : 'Thêm quyền hạn mới'}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={
            <span>
              Tên quyền hạn <span style={{ color: 'red' }}>*</span>
            </span>
          }
          name="name"
          rules={[
            { required: true, message: 'Vui lòng nhập tên quyền hạn!' },
            { min: 2, message: 'Tên quyền hạn phải có ít nhất 2 ký tự!' },
            { pattern: /^[a-z0-9_]+$/, message: 'Tên quyền chỉ được chứa chữ thường, số và dấu _' }
          ]}>
          <Input placeholder="Ví dụ: user_create, report_view..." />
        </Form.Item>

        <Form.Item
          label={
            <span>
              Mô tả <span style={{ color: 'red' }}>*</span>
            </span>
          }
          name="description"
          rules={[
            { required: true, message: 'Vui lòng nhập mô tả!' },
            { max: 500, message: 'Mô tả không được vượt quá 500 ký tự!' }
          ]}>
          <Input.TextArea rows={3} placeholder="Mô tả chức năng của quyền hạn này..." />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Hủy
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ backgroundColor: '#0051A9', borderColor: '#0051A9' }}>
            {editingPermission ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PermissionFormModal;
